<template>
  <v-tooltip top max-width="300px">
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        v-bind="attrs"
        :color="$vuetify.theme.dark ? 'white' : 'softTextGrey'"
        v-on="on"
        @click="$emit('clicked')"
      >
        mdi-update
      </v-icon>
    </template>
    <span>{{ text }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '',
    },
  },
}
</script>
